import { TIMEZONE_LABELS } from '../../../components/TimezoneSelector/constants'
import { getGmtOffsetLabel } from '../../../components/TimezoneSelector/utils'
import { type BookingClient } from '../../../models/Scheduling'

export const clientDisplayName = (client: BookingClient): string => [client.firstName, client.lastName].filter(Boolean).join(' ') || client.email || 'Client'

export interface BrandColorOption {
  name: string
  hex: string
}

export const BRAND_COLOR_PRESETS: BrandColorOption[] = [
  { name: 'Zocks purple', hex: '#7749F8' },
  { name: 'Blue', hex: '#1F4ED8' },
  { name: 'Sky', hex: '#0EA5E9' },
  { name: 'Green', hex: '#16A34A' },
  { name: 'Amber', hex: '#F59E0B' },
  { name: 'Yellow', hex: '#F5E500' },
  { name: 'Red', hex: '#DC2626' },
  { name: 'Pink', hex: '#DB2777' },
  { name: 'Slate', hex: '#334155' },
]

export const brandColorName = (hex: string) => BRAND_COLOR_PRESETS.find((preset) => preset.hex.toLowerCase() === hex.toLowerCase())?.name ?? 'Custom'

export const formatTimezoneLabel = (ianaTimezone: string) => {
  const label = Object.entries(TIMEZONE_LABELS).find(([, tz]) => tz === ianaTimezone)?.[0] ?? ianaTimezone
  return `${getGmtOffsetLabel(ianaTimezone)} ${label}`
}
